import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { EyeSvg } from './Eye';

export const EyeIcon = createIcon('eye', EyeSvg);
/**
 * @deprecated используйте EyeIcon
 */
export const withEyeIcon = withIcon('eye', EyeSvg);
